import { VehicleDetail } from "../types";

export * from "./serializeVehicleDetail";


export const getDefaultVehicle = (listOfVehicles: VehicleDetail[]) => {
    let defaultVehicle: VehicleDetail;
    const primaryVehicle = listOfVehicles?.find((item) => item.isDefault);
    if (primaryVehicle) {
      defaultVehicle = primaryVehicle;
    } else if (!primaryVehicle && listOfVehicles.length) {
      const firstVehicle = listOfVehicles[0];
      defaultVehicle = firstVehicle;
    }
    return defaultVehicle;
  };